var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgChangeUser = function SvgChangeUser(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_20137",
    "data-name": "Group 20137",
    opacity: 0.749
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11300",
    "data-name": "Path 11300",
    d: "M17,959.362a10,10,0,0,0-6.744,17.376v.065h.073a9.978,9.978,0,0,0,13.343,0h.073v-.065A10,10,0,0,0,17,959.362Zm0,.465a9.538,9.538,0,0,1,6.744,16.279v-2.093a3.022,3.022,0,0,0-3.023-3.023H13.279a3.022,3.022,0,0,0-3.023,3.023v2.093A9.538,9.538,0,0,1,17,959.827Zm0,1.628a3.953,3.953,0,1,0,3.953,3.953A3.957,3.957,0,0,0,17,961.455Zm0,.465a3.488,3.488,0,1,1-3.488,3.488A3.485,3.485,0,0,1,17,961.92Zm-3.721,9.535h7.442a2.547,2.547,0,0,1,2.558,2.558v2.522a9.527,9.527,0,0,1-12.558,0v-2.522a2.547,2.547,0,0,1,2.558-2.558Z",
    transform: "translate(-7 -959.362)",
    fill: "#fff"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChangeUser, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/changeUser.69ad67e9.svg";
export { ForwardRef as ReactComponent };